import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'

export default {
  getUsers: async () => fetchApi.get(constants.ENDPOINT_USERS),
  editUser: async (user) => fetchApi.put(`${constants.ENDPOINT_USERS}/${user._id}`, user),
  getUserById: async (id) => fetchApi.get(`${constants.ENDPOINT_USERS}/${id}`),
}
